module.exports = __webpack_public_path__ + "img/P150T_weapon_113.c15e935d.png";